import { gql } from '@apollo/client';

const ITEM_FIELD_FRAGMENT = gql`
  fragment ItemFieldFragment on ItemFieldType {
    field_name
    field_type
    uuid
    value
    description
    position
    displaying_size
    required
    writeable
    options
    children
    url
    pre_name
    type
    default_value
  }
`;

const ITEM_LABEL_FRAGMENT = gql`
  fragment ItemLabelFragment on ItemLabelType {
    text
    color
    filterable
  }
`;

export const ITEM_FRAGMENT = gql`
  fragment ItemFragment on ItemType {
    id
    item {
      ...ItemFieldFragment
    }
    labels {
      ...ItemLabelFragment
    }
    backgroundColor
  }
  ${ITEM_FIELD_FRAGMENT}
  ${ITEM_LABEL_FRAGMENT}
`;

export const GET_ITEMS = gql`
  query Items($itemModelId: Int!, $filter: JSON, $limit: Int, $offset: Int) {
    items(
      itemModelId: $itemModelId
      filter: $filter
      limit: $limit
      offset: $offset
    ) {
      count
      results {
        ...ItemFragment
      }
      globalActions
      deletePermission
    }
  }
  ${ITEM_FRAGMENT}
`;

export const GET_ITEM = gql`
  query Item($id: Int!) {
    item(id: $id) {
      ...ItemFragment
    }
  }
  ${ITEM_FRAGMENT}
`;

export const CREATE_ITEM = gql`
  mutation CreateItem($input: CreateItemInput!) {
    createItem(input: $input) {
      ...ItemFragment
    }
  }
  ${ITEM_FRAGMENT}
`;

export const UPDATE_ITEM = gql`
  mutation UpdateItem($input: UpdateItemInput!) {
    updateItem(input: $input) {
      ...ItemFragment
    }
  }
  ${ITEM_FRAGMENT}
`;

export const DELETE_ITEM = gql`
  mutation DeleteItem($id: Int!) {
    deleteItem(id: $id)
  }
`;

export const GET_FILTERS = gql`
  query Filters($itemModelId: Int!) {
    filters(itemModelId: $itemModelId) {
      uuid
      field_name
      field_type
      displaying_size
      description
      itemModelId
      options {
        label
        value
      }
      writeable
      default_value
    }
  }
`;

export const GET_ITEM_MODEL = gql`
  query ItemModel($id: Int!) {
    itemModel(id: $id) {
      id
      name
      model
      subpageType
      dataType
      titleFields
      position
      groupsWithDeleteAccess
      groupsWithViewAccess
      canCreatorSeeItems
      companyId
      keepHistoryOfFields
      patchUrl
      deleteUrl
      orderBy
      orderByAsc
    }
  }
`;
